var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { deleteCookie, findCookie } from 'app/core/cookie';
function safeMunchkinInvoke(fn) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var munchkin = window.Munchkin;
    if (munchkin && munchkin[fn]) {
        munchkin[fn].apply(munchkin, __spread(args));
    }
}
function munchkinFunction() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    safeMunchkinInvoke.apply(void 0, __spread(['munchkinFunction'], args));
}
function associateLead(properties, hash) {
    munchkinFunction('associateLead', properties, hash);
}
function clickLink(href, params) {
    if (params === void 0) { params = null; }
    munchkinFunction('clickLink', { href: href, params: params });
}
function visitWebPage(url, params) {
    if (params === void 0) { params = null; }
    munchkinFunction('visitWebPage', { url: url, params: params });
}
var cookieName = '_mkto_trk';
function getCookie() {
    return findCookie(cookieName);
}
function logout() {
    deleteCookie(cookieName);
    safeMunchkinInvoke('createTrackingCookie', true);
}
export default {
    associateLead: associateLead,
    clickLink: clickLink,
    visitWebPage: visitWebPage,
    getCookie: getCookie,
    logout: logout
};
